<script>
import Breadcrumb from '@/components/Breadcrumb'

export default {
  mounted () {
    // set title
    this.title = this.$route.meta.title
  },
  watch: {
    // change title on route updates
    '$route' (to, from) {
      if (to.meta && to.meta.title) {
        this.title = to.meta.title
      }
    }
  },
  data () {
    return {
      title: ''
    }
  },

  components: {
    Breadcrumb
  }
}
</script>

<template>
  <div>
    <div class="row mt-4 td-4">
      <div class="col-md-12">
        <h3 class="report-title text-center">{{title}}</h3>
      </div>
    </div>
    <Breadcrumb></Breadcrumb>
    <router-view></router-view>
  </div>
</template>

<style>
.list-group-item-heading {
  color: #ffffff!important;
}
.report-title {
  color:#ffffff;
}

</style>
